module.exports = __webpack_public_path__ + "static/media/qr-scan.466dd464.gif";